import { jsx } from "react/jsx-runtime";
import Button from "@ingka/button";
import clearIcon from "@ingka/ssr-icon/paths/cross-small";
const ClearButton = ({
  baseClass,
  prefix,
  clearBtnText,
  onClick,
  hidden
}) => /* @__PURE__ */ jsx(
  Button,
  {
    prefix,
    className: `${baseClass}__action ${baseClass}__clear`,
    type: "tertiary",
    size: "xsmall",
    iconOnly: true,
    ssrIcon: clearIcon,
    text: clearBtnText,
    onClick,
    "aria-hidden": hidden,
    disabled: hidden
  }
);
export {
  ClearButton
};
